export class LastKnownNotificationIdRepresentation {

  notificationId: number;

  constructor(notificationId: number) {
    this.notificationId = notificationId;
  }

}
